/**
 * Global initialization module for Vue application
 * Handles installation of global utilities, stores, and shared context
 */

// ServicesUtils
import { installGlobalAudioPlayer } from "@/components/media/audioPlayer/GlobalAudioPlayer.js";

// Stores
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useLyricDataStore from "@/store/create/lyricDataStore.js";

import layoutConfig, { initLayout, initLayoutSSR } from "@/config/layoutConfig.js";


export const installGlobalUtils = (app) => {
  installGlobalAudioPlayer(app);
  initLayout(app);
};


export const installStoreLocalState = (app) => {
  const stores = {
    createLayoutStore: useCreateLayoutStore(),
    lyricDataStore: useLyricDataStore()
  };

  Object.values(stores).forEach(store => store.initLocalState?.());

  if (window.vueApp.appContext?.config?.globalProperties) {
    window.vueApp.appContext.config.globalProperties.$stores = stores;
  }
};



export const registWindowListener = (event, callback) => {
  function onResize() {
    // 在窗口大小变化时重新加载路由
    // 设备没有变化，取消重新渲染
    // 普通页面不重新渲染
    const type = window.innerWidth > 768 ? "pc" : "mobile";
    if (type == layoutConfig.renderType) return;
    initLayout();
  }

  window.addEventListener("resize", onResize);
};


export const globalInstall = (app) => {
  window.vueApp = app; // 便于js里面直接调用vue实例
  window.$getVueCurrentInstance = () => {
    return app
  }

  installGlobalUtils(app);
  installStoreLocalState(app);
  registWindowListener();
};


export const beforeCreateGlobalInstall =(app, userAgent) => {
  initLayoutSSR(app, userAgent);
  
}

export default {
  beforeCreateGlobalInstall: beforeCreateGlobalInstall,
  globalInstall: globalInstall,
  installGlobalUtils,
  installStoreLocalState,
  registWindowListener,
};